import { MouseEvent, useEffect, useState } from "react";
import { IMinerErrorsProps } from "./MinerErrors.props";
import useTypedRequest from "@utils/hooks/useTypedRequest";
import {
  getMinerErrors,
  getMinerHistoryErrors,
  IMinerErrors,
  resetMinerErrors,
} from "@services/minerErrors";
import { useMinerContext } from "../../../MinerContext";
import { useAuth } from "@utils/hooks/useAuth";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { makeNotifs } from "@utils/makeNotifs";
import { MinerActions } from "../../../minerReducer";

export const useMinerErrorsControl = (props: IMinerErrorsProps) => {
  const { ok } = makeNotifs();
  const { onLoader, onSuccess } = useGlobalNotifs();
  const { isAdmin } = useAuth();
  const { miner, dispatchMiner } = useMinerContext();
  const { request: getErrors } = useTypedRequest(getMinerErrors);
  const { request: getHistoricalErrors, loading: historicalLoader } =
    useTypedRequest(getMinerHistoryErrors);
  const { request: resetErrors, loading } = useTypedRequest(resetMinerErrors);
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState<IMinerErrors[]>([]);
  const [errorsHistory, setErrorsHistory] = useState<IMinerErrors[]>([]);

  useEffect(() => {
    onLoader(loading || historicalLoader);
  }, [loading, historicalLoader]);

  const onToggle = () => {
    setShow(!show);
  };

  // const getErrors = async () => {
  //   const res = await request(miner.id);

  //   if (!res) return;
  //   setErrors(res.Records);
  // };

  // const getErrorsHistory = async () => {
  //   const res = await getHistoricalErrors(miner.id);

  //   if (!res) return;
  //   setErrorsHistory(res.Records);
  // };

  const onClearErrors = async (e?: MouseEvent<HTMLSpanElement>) => {
    if (!isAdmin) return;
    e?.stopPropagation();
    const ids = errors.map((err) => err.Id);
    const res = await resetErrors(ids, miner.id);

    if (!res) return;
    setErrorsHistory((prev) => [...prev, ...errors]);
    setErrors([]);
    onSuccess(ok.success);
    dispatchMiner({
      type: MinerActions.Miner,
      payload: { ...miner, has_errors: false },
    });
  };
  useEffect(() => {
    if (!isAdmin) return;
    let isMounted = true;

    // getErrors();
    // getErrorsHistory();
    async function fetchErrors() {
      const res = await getErrors(miner.id);
      if (!res || !isMounted) return;
      setErrors(res.Records);
      const resHistory = await getHistoricalErrors(miner.id);
      if (!resHistory || !isMounted) return;
      setErrorsHistory(resHistory.Records);
    }
    fetchErrors();
    //   const res = await getErrors(miner.id);
    //   if (!res) return;
    //   setErrors(res.Records);

    //   const res = await getHistoricalErrors(miner.id);
    //   if (!res) return;
    //   setErrorsHistory(res.Records);

    return () => {
      isMounted = false;
    };
  }, [miner.has_errors]);

  return {
    show,
    errors,
    errorsHistory,

    onToggle,
    onClearErrors,
  };
};
